import { apiClient } from './authService';

// Promotions (POS): a single product at a promo price, or a pack/bundle.
const multipartCfg = (payload) =>
  payload instanceof FormData ? { headers: { 'Content-Type': 'multipart/form-data' } } : undefined;

const promoService = {
  getPromos: async () => {
    const res = await apiClient.get('products/promos/?page_size=1000');
    const d = res.data;
    return Array.isArray(d) ? d : (d.results || []);
  },
  // Active promos only — used by the POS to apply prices.
  getActivePromos: async () => {
    const res = await apiClient.get('products/promos/?active=1&page_size=1000');
    const d = res.data;
    return Array.isArray(d) ? d : (d.results || []);
  },
  createPromo: async (payload) => {
    const res = await apiClient.post('products/promos/', payload, multipartCfg(payload));
    return res.data;
  },
  updatePromo: async (id, payload) => {
    const res = await apiClient.patch(`products/promos/${id}/`, payload, multipartCfg(payload));
    return res.data;
  },
  deletePromo: async (id) => {
    await apiClient.delete(`products/promos/${id}/`);
  },
};

export default promoService;
